import {Menu} from './menu';
import {Backdrop} from '../backdrop';

export class Search {

    readonly searchElementId = 'header-search';
    readonly searchInputId = 'header-search-input';

    constructor(private menu: Menu, private backdrop: Backdrop) {
        backdrop.addOnClickCallback(this.close.bind(this));
    }

    public open(): void {
        this.menu.close();
        this.backdrop.show();
        this.getSearchElement()?.classList.remove('d-none');
        this.focusSearchInput();
    }

    public close(): void {
        this.backdrop.hide();
        this.getSearchElement()?.classList.add('d-none');
    }

    private getSearchElement(): HTMLElement {
        let searchElement = document.getElementById(this.searchElementId);
        if (searchElement !== null) {
            return searchElement;
        }
        return null;
    }

    private getInputElement(): HTMLInputElement {
        let searchInput = document.getElementById(this.searchInputId);
        if (searchInput instanceof HTMLInputElement) {
            return searchInput;
        }
        return null;
    }

    public focusSearchInput(): void {
        this.getInputElement().focus();
    }

    public search(): void {
        let searchValue = this.getInputElement().value;
        window.location.href = '/?s=' + searchValue;
    }
}
